module.exports = __webpack_public_path__ + "img/upload.7501576e.svg";